module.exports = function() {
  return new Worker(__webpack_public_path__ + "30c9d5f587acf772fbb1.worker.js");
};